exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (max-width: 767px) {\n.select2-selection__placeholder {\n        padding-right: 40px;\n}\n}\n", ""]);

// exports
